import { __generator } from "tslib";
import { put, select, takeLatest } from 'redux-saga/effects';
import * as actionCreators from '../actionCreators';
import * as actionTypes from '../constants/actionTypes';
import { getDefaultCodeLang } from '../selectors/code';
var projectActions = [
    actionTypes.LOAD_FULL_PROJECT_DONE,
    actionTypes.LOAD_PROJECT_PREVIEW_DONE,
    actionTypes.SET_PROJECT,
];
export default function setCodeLang() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(projectActions, function () {
                    var codeLang;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, select(getDefaultCodeLang)];
                            case 1:
                                codeLang = _a.sent();
                                return [4 /*yield*/, put(actionCreators.setDefaultProjectLang(codeLang))];
                            case 2:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
